import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";

const CircularProgress = ({ value, min=0, max=100, size=40, thickness=4, color=null, backgroundColor=null, label=null, style={} }) => {
    const normalizedValueFromRange = value => {
        return ((value - min) * 100) / (max - min);
    }

    return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", ...style }}>
            <MuiCircularProgress
                variant="determinate"
                sx={{
                    color: backgroundColor ? backgroundColor : "var(--wnp-color-secondary-extralight)",
                    position: "absolute"
                }}
                size={size}
                thickness={thickness}
                value={100}
            />
            <MuiCircularProgress
                variant="determinate"
                sx={{
                    color: color ? color : "var(--wnp-color-primary)",
                    position: "absolute"
                }}
                size={size}
                thickness={thickness}
                value={normalizedValueFromRange(value)}
            />
            <div style={{ height: `${size}px`, width: `${size}px`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                {label}
            </div>
        </div>
    )
}

export default CircularProgress;
